import React, { useRef, useEffect } from 'react';

const HtmlTextBlock = ({ translatedBlock, handleEdit, index }) => {
    const textareaRef = useRef(null);

    // Auto-resize effect
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // reset
            textareaRef.current.style.height = textareaRef.current.scrollHeight + "px"; // expand
        }
    }, [translatedBlock?.text]);

    const handleChange = (e) => {
        handleEdit(translatedBlock, index, e.target.value);

        // adjust height while typing
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
        }
    };

    return (
        <textarea
            ref={textareaRef}
            rows={1} // start with 1 row
            className="w-100 border-0 p-1"
            style={{
                overflow: 'hidden',
                textAlign: 'start',
                fontSize: '14px',
                lineHeight: '1.5',
                borderRadius: '5px',
                backgroundColor: '#fff',
                outline: 'none',
                resize: 'none' // disable manual resize, let auto-resize handle it
            }}
            value={translatedBlock?.text || ''}
            onChange={handleChange}
        />
    );
};

export default HtmlTextBlock;
